import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ClientsService } from '../services/clients/clients.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private usersService: ClientsService,
    private router: Router) {
  }

  canActivate(): boolean {
    if (this.usersService.isConnected()) {
      return true
    } else {
      this.router.navigate(['/login'])
      return false
    }
  }
  
}
